<section class="modal modal--{{modalData.type}}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="flex-always flex--space-between">
          <p class="modal-title">{{modalData.title}}</p>
          <a href="javascript:void(0);" class="modal-close" (click)="close($event)">{{modalData.cancelButtonText ? modalData.cancelButtonText : 'Cancel'}}<i class="icon">cross</i></a>
        </div>
      </div>
      <div class="modal-body">
        <!-- <p class="">{{modalData.content}} <b>{{modalData.flightData.operatingAirlineName}}</b></p> -->
          <!-- <img [src]="'./images/airline-logo-full/' + airlineName + '.svg'" alt="Operating Airline" srcset=""> -->
        <div *ngFor="let item of modalData.flightData.flightStatusDetails" class="section">
            <p>{{modalData.copyData.airline}}: <b>{{item?.operatingAirlineName}}</b></p>
            <p>{{modalData.copyData.flightNumber}}: {{item?.operatingAirlineCode}}{{item?.operatingFlightNumber}}</p>
        </div>
      </div>
    </div>
  </div>
</section>
